var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "col-12 col-lg-9 row h-100 m-0 p-0 pr-lg-0",
      staticStyle: { "transition-delay": "0s" }
    },
    [
      _c(
        "div",
        { staticClass: "scroll-panel col-12 col-lg-4 p-0 m-0 pl-lg-2 h-100" },
        [
          _c("Questionnaires", {
            ref: "questionnaire",
            attrs: { user: _vm.user }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "scroll-panel col-12 col-lg-4 p-0 m-0 pl-lg-2 h-100" },
        [
          _c("Questionnaires", {
            ref: "vote",
            attrs: { user: _vm.user, is_vote: 1 }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "scroll-panel col-12 col-lg-4 p-0 m-0 pl-lg-4 h-100 section"
        },
        [
          _c("Kudos", {
            attrs: { title: "Latest Kudos!", user: _vm.user, limit: "3" }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc7cce2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 